<template>
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div
        class="form-title padding-title"
        v-text="'Reclamo'"
      />
      <div class="form-box-body">
        <vuescroll>
          <div class="form-components scroll">
            <div
              class="form_label"
              v-text="text"
            />
            <div
              class="form_label"
              v-text="'Nombre *'"
            />
            <div class="form__field">
              <label for="name"><v-icon
                name="user"
                scale="1"
              /></label>
              <input
                id="nombre"
                ref="nombre"
                v-model="nombre"
                autocomplete="off"
                type="text"
                name="nombre"
                value=""
                placeholder="Nombre"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'nombre')"
                @change="cleanSpecialChars('nombre', 'nombre')"
              >
            </div>
            <!-- 5 -->
            <div
              class="form_label"
              v-text="'Correo electrónico *'"
            />
            <div class="form__field">
              <label
                for="correo"
              ><v-icon
                name="envelope"
                scale="1"
              /></label>
              <input
                id="correo"
                ref="correo"
                v-model="correo"
                class="correo"
                autocomplete="off"
                type="text"
                name="correo"
                value=""
                placeholder="usuario@dominio.com"
                required
                @focus="_clearError"
              >
            </div>
            <!-- 6 -->
            <div
              class="form_label"
              v-text="'Teléfono *'"
            />
            <div class="form__field">
              <label
                for="telefono"
              ><v-icon
                name="mobile-alt"
                scale="1"
                style="margin: 0 2px 3px 4px"
              /></label>
              <input
                id="telefono"
                ref="telefono"
                v-model="telefono"
                autocomplete="off"
                type="text"
                name="telefono"
                value=""
                placeholder="+569 1 234 5678"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'phone')"
                @change="cleanSpecialChars('telefono', 'phone')"
              >
            </div>
            <!-- 1 -->
            <div
              class="form_label"
              v-text="'Producto'"
            />
            <div class="form__field">
              <select
                id="form_estilos"
                v-model="producto_reclamo"
                :multiple="false"
                class="form_combo"
              >
                <option value>
                  SELECCIONA PRODUCTO
                </option><option value="1865">
                  1865
                </option><option value="7 Up">
                  7 Up
                </option><option value="Absolut">
                  Absolut
                </option><option value="Adrenaline">
                  Adrenaline
                </option><option value="Altaïr">
                  Altaïr
                </option><option value="Austral">
                  Austral
                </option><option value="Ballantine's">
                  Ballantine's
                </option><option value="Beefeater">
                  Beefeater
                </option><option value="Bilz">
                  Bilz
                </option><option value="Pap">
                  Pap
                </option><option value="Blue Moon">
                  Blue Moon
                </option><option value="Cabo de Hornos">
                  Cabo de Hornos
                </option><option value="Cachantun">
                  Cachantun
                </option><option value="Campanario">
                  Campanario
                </option><option value="Campanario Selección">
                  Campanario Selección
                </option><option value="Canada Dry">
                  Canada Dry
                </option><option value="Casa Rivas">
                  Casa Rivas
                </option><option value="Castillo de Molina">
                  Castillo de Molina
                </option><option value="Chivas Regal">
                  Chivas Regal
                </option><option value="Control C">
                  Control C
                </option><option value="Coors">
                  Coors
                </option><option value="Cristal">
                  Cristal
                </option><option value="Crush">
                  Crush
                </option><option value="Cygan">
                  Cygan
                </option><option value="D'olbek">
                  D'olbek
                </option><option value="Dorada">
                  Dorada
                </option><option value="Epica">
                  Epica
                </option><option value="Escudo">
                  Escudo
                </option><option value="Espíritu de los Andes">
                  Espíritu de los Andes
                </option><option value="Fehrenberg">
                  Fehrenberg
                </option><option value="Frugo">
                  Frugo
                </option><option value="G.H. Mumm">
                  G.H. Mumm
                </option><option value="Gato Negro">
                  Gato Negro
                </option><option value="Gatorade">
                  Gatorade
                </option><option value="Guayacán">
                  Guayacán
                </option><option value="Hard Fresh">
                  Hard Fresh
                </option><option value="Havana Club">
                  Havana Club
                </option><option value="Heineken">
                  Heineken
                </option><option value="Horcón Quemado">
                  Horcón Quemado
                </option><option value="Iceberg">
                  Iceberg
                </option><option value="Imperial">
                  Imperial
                </option><option value="Jameson">
                  Jameson
                </option><option value="Kahlúa">
                  Kahlúa
                </option><option value="Kankana del Elqui">
                  Kankana del Elqui
                </option><option value="Kantal">
                  Kantal
                </option><option value="Kem">
                  Kem
                </option><option value="Kem Xtreme">
                  Kem Xtreme
                </option><option value="Kunstmann">
                  Kunstmann
                </option><option value="La Celia">
                  La Celia
                </option><option value="La Serena">
                  La Serena
                </option><option value="Las Encinas">
                  Las Encinas
                </option><option value="Leyda">
                  Leyda
                </option><option value="Limón Soda">
                  Limón Soda
                </option><option value="Lipton Ice Tea">
                  Lipton Ice Tea
                </option><option value="MAS">
                  MAS
                </option><option value="MAS Woman">
                  MAS Woman
                </option><option value="Malibu">
                  Malibu
                </option><option value="Manantial">
                  Manantial
                </option><option value="Martell">
                  Martell
                </option><option value="Misiones de Rengo">
                  Misiones de Rengo
                </option><option value="Mistral">
                  Mistral
                </option><option value="Mistral Ice">
                  Mistral Ice
                </option><option value="Morenita">
                  Morenita
                </option><option value="Mumm">
                  Mumm
                </option><option value="Nestlé Pura Vida">
                  Nestlé Pura Vida
                </option><option value="Olmeca">
                  Olmeca
                </option><option value="Pepsi">
                  Pepsi
                </option><option value="Perrier">
                  Perrier
                </option><option value="Porvenir">
                  Porvenir
                </option><option value="Ramazzotti">
                  Ramazzotti
                </option><option value="Red Bull">
                  Red Bull
                </option><option value="Rockstar">
                  Rockstar
                </option><option value="Royal Guard">
                  Royal Guard
                </option><option value="Royal Salute">
                  Royal Salute
                </option><option value="Sabor Andino Sour">
                  Sabor Andino Sour
                </option><option value="Santa Helena">
                  Santa Helena
                </option><option value="Sideral">
                  Sideral
                </option><option value="Sierra Morena">
                  Sierra Morena
                </option><option value="Sierra Morena Mojito Ice">
                  Sierra Morena Mojito Ice
                </option><option value="Sol">
                  Sol
                </option><option value="Sprim">
                  Sprim
                </option><option value="Stones">
                  Stones
                </option><option value="Szot">
                  Szot
                </option><option value="Tarapacá">
                  Tarapacá
                </option><option value="The Glenlivet">
                  The Glenlivet
                </option><option value="Tierras Moradas">
                  Tierras Moradas
                </option><option value="Tres Erres">
                  Tres Erres
                </option><option value="Villa Pehuenia">
                  Villa Pehuenia
                </option><option value="Vivo">
                  Vivo
                </option><option value="Viñamar">
                  Viñamar
                </option><option value="Watt's">
                  Watt's
                </option><option value="Watt’s Selección">
                  Watt’s Selección
                </option><option value="Wyborowa">
                  Wyborowa
                </option>
              </select>
            </div>
            <!-- 2 -->
            <div
              class="form_label"
              v-text="'Línea *'"
            />
            <div class="form__field">
              <label
                v-tooltip="{content: `<img style='z-index: 10000; position='fixed';'  src='https://www.ccu.cl/wp-content/themes/ccu/img/codificado.png' width='100%' height='100%' />`, html: true, show: false}"
                for="linea"
              ><v-icon
                name="question"
                scale="1"
              /></label>
              <input
                id="linea"
                ref="linea"
                v-model="linea"
                autocomplete="off"
                type="text"
                name="linea"
                value=""
                placeholder="bebidas, cervezas, etc."
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'linea')"
              >
            </div>
            <!-- 3 -->
            <div
              class="form_label"
              v-text="'Fecha *'"
            />
            <div class="form__field">
              <label
                v-tooltip="{content: `<img style='z-index: 100000;' src='https://www.ccu.cl/wp-content/themes/ccu/img/codificado.png' width='100%' height='100%' />`,autoHide:false,disposeTimeout:70000, html: true, show: false}"
                for="linea"
              ><v-icon
                name="calendar"
                scale="1"
              /></label>
              <input
                id="fecha"
                ref="fecha"
                v-model="fecha"
                autocomplete="off"
                type="date"
                name="fecha"
                value=""
                placeholder=""
                required
                @focus="_clearError"
              >
            </div>
            <!-- 4 -->

            <!-- 7 -->
            <div
              class="form_label"
              v-text="'Tamaño *'"
            />
            <div class="form__field">
              <label
                for="tamano"
              ><v-icon
                name="window-maximize"
                scale="1"
              /></label>
              <input
                id="tamano"
                ref="tamano"
                v-model="tamano"
                autocomplete="off"
                type="text"
                name="tamano"
                value=""
                placeholder=""
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'tamano')"
                @change="cleanSpecialChars('tamano', 'tamano')"
              >
            </div>
            <!-- 8 -->
            <div
              class="form_label"
              v-text="'Hora *'"
            />
            <div class="form__field">
              <label for="hora"><v-icon
                name="clock"
                scale="1"
              /></label>
              <input
                id="hora"
                ref="hora"
                v-model="hora"
                autocomplete="off"
                type="text"
                name="hora"
                value=""
                placeholder="15:00"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('hora')"
                @keypress="keyPressCheckSpecialChars($event, 'hora')"
                @change="cleanSpecialChars('hora', 'hora')"
              >
            </div>
            <!-- 9 -->

            <!-- 10 -->
            <div
              class="form_label"
              v-text="'RUT *'"
            />
            <div class="form__field">
              <label
                for="rut"
              ><v-icon
                name="address-card"
                scale="1"
              /></label>
              <input
                id="rut"
                ref="rut"
                v-model="rut"
                autocomplete="off"
                type="text"
                name="rut"
                value=""
                placeholder="XX.XXX.XXX-X"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'rut')"
                @change="_formatearRut($event.target.value)"
              >
            </div>
            <!-- 11 -->
            <div
              class="form_label"
              v-text="'Dirección *'"
            />
            <div class="form__field">
              <label
                for="ciudad"
              ><v-icon
                name="city"
                scale="1"
              /></label>
              <input
                id="ciudad"
                ref="ciudad"
                v-model="ciudad"
                autocomplete="off"
                type="text"
                name="ciudad"
                value=""
                placeholder="Santiago"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'ciudad')"
                @change="cleanSpecialChars('ciudad', 'ciudad')"
              >
            </div>
            <!-- 12 -->
            <div
              class="form_label"
              v-text="'Region *'"
            />
            <div class="form__field">
              <select
                id="form_estilos"
                v-model="selectedRegion"
                :multiple="false"
                class="form_combo"
                @change="updateComunas"
              >
                <option value>
                  SELECCIONA REGIÓN
                </option>
                <option
                  v-for="(nombre, index) in regiones"
                  :value="index"
                >
                  {{ nombre.nombre }}
                </option>
              </select>
            </div>
            <!-- 13 -->
            <div
              class="form_label"
              v-text="'Comuna'"
            />
            <div class="form__field">
              <select
                id="form_estilos"
                v-model="selectedComuna"
                :multiple="false"
                class="form_combo"
              >
                <option value>
                  SELECCIONA COMUNA
                </option>
                <option
                  v-for="comuna in comunas"
                  :value="comuna"
                >
                  {{ comuna }}
                </option>
              </select>
            </div>
            <!-- IMAGEN --><!-- IMAGEN -->
            <div class="form__field">
              <input
                class="form_image"
                type="file"
                accept="image/*"
                @change="handleImageUpload"
              >
            </div>
            <div
              v-if="image"
              class="form__field"
            >
              <img
                :src="image"
                alt="Imagen seleccionada"
                class="max-image-size"
              >
            </div>
            <!-- IMAGEN --><!-- IMAGEN -->
            <!-- TEXTAREA -->
            <div
              class="score-subtitle"
              style="margin-bottom: 5px;"
            >
              ¿Qué pasó con tu producto?
            </div>
            <div class="score-comments">
              <textarea
                v-model="productoQ"
                placeholder="Deja tu mensaje"
                @keypress="keyPressCheckSpecialChars($event, 'productoQ')"
                @change="cleanSpecialChars('productoQ', 'productoQ')"
              />
            </div>
          </div>
        </vuescroll>
      </div>

      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          Enviar
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>

<script>
import { serverUI } from './main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/map-marker-alt'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/store'
import 'vue-awesome/icons/comment'
import 'vue-awesome/icons/id-card'
import 'vue-awesome/icons/barcode'
import 'vue-awesome/icons/clock'
import 'vue-awesome/icons/tools'
import 'vue-awesome/icons/mobile-alt'
import 'vue-awesome/icons/city'
import 'vue-awesome/icons/question-circle'
import 'vue-awesome/icons/window-maximize'
import utils from './utils'

export default {
  components: {
    'v-icon': Icon
  },
  props: {},
  data () {
    return {
      selectedRegion: '',
      selectedComuna: '',
      regiones: [
        {
          nombre: 'Arica y Parinacota',
          comunas: ['Arica', 'Camarones', 'Putre', 'General Lagos']
        },
        {
          nombre: 'Tarapacá',
          comunas: ['Iquique', 'Alto Hospicio', 'Pozo Almonte']
        },
        {
          nombre: 'Región Antofagasta',
          comunas: ['Antofagasta', 'Mejillones', 'Sierra Gorda', 'Taltal', 'Calama', 'Ollagüe', 'San Pedro de Atacama', 'Tocopilla', 'María Elena']
        },
        {
          nombre: 'Región Atacama',
          comunas: ['Copiapó', 'Tierra Amarilla', 'Chañaral', 'Diego de Almagro', 'Vallenar', 'Alto del Carmen', 'Freirina', 'Huasco']
        },
        {
          nombre: 'Región Coquimbo',
          comunas: ['La Serena', 'Coquimbo', 'Andacollo', 'La Higuera', 'Paiguano', 'Vicuña', 'Illapel', 'Canela', 'Los Vilos', 'Salamanca', 'Ovalle', 'Combarbalá', 'Monte Patria', 'Punitaqui']
        },
        {
          nombre: 'Región Valparaíso',
          comunas: ['Valparaíso', 'Casablanca', 'Concón', 'Juan Fernández', 'Puchuncaví', 'Quintero', 'Viña del Mar', 'Isla de Pascua', 'Los Andes', 'Calle Larga', 'Rinconada', 'San Esteban', 'La Ligua', 'Cabildo', 'Papudo', 'Petorca', 'Zapallar', 'Quillota', 'Calera', 'Hijuelas', 'La Cruz', 'Nogales', 'San Antonio', 'Algarrobo', 'Cartagena', 'El Quisco', 'El Tabo', 'Santo Domingo', 'San Felipe', 'Catemu', 'Llay-Llay', 'Panquehue', 'Putaendo', 'Santa María', 'Quilpué', 'Limache', 'Olmué']
        },
        {
          nombre: 'Metropolitana',
          comunas: ['Santiago', 'Cerrillos', 'Cerro Navia', 'Conchalí', 'El Bosque', 'Estación Central', 'Huechuraba', 'Independencia', 'La Cisterna', 'La Florida', 'La Granja', 'La Pintana', 'La Reina', 'Las Condes', 'Lo Barnechea', 'Lo Espejo', 'Lo Prado', 'Macul', 'Maipú', 'Ñuñoa', 'Pedro Aguirre Cerda', 'Peñalolén', 'Providencia', 'Pudahuel', 'Quilicura', 'Quinta Normal', 'Recoleta', 'Renca', 'San Joaquín', 'San Miguel', 'San Ramón', 'Vitacura', 'Puente Alto', 'Pirque', 'San José de Maipo', 'Colina', 'Lampa', 'Tiltil', 'San Bernardo', 'Buin', 'Calera de Tango', 'Paine', 'Melipilla', 'Alhué', 'Curacaví', 'María Pinto', 'San Pedro', 'Talagante', 'El Monte', 'Isla de Maipo', 'Padre Hurtado', 'Peñaflor']
        },
        {
          nombre: 'O`Higgins',
          comunas: ['Rancagua', 'Codegua', 'Coinco', 'Coltauco', 'Doñihue', 'Graneros', 'Las Cabras', 'Machalí', 'Malloa', 'Mostazal', 'Olivar', 'Peumo', 'Pichidegua', 'Quinta de Tilcoco', 'Rengo', 'Requínoa', 'San Vicente', 'Pichilemu', 'La Estrella', 'Litueche', 'Marchihue', 'Navidad', 'Paredones', 'San Fernando', 'Chépica', 'Chimbarongo', 'Lolol', 'Nancagua', 'Palmilla', 'Peralillo', 'Placilla', 'Pumanque', 'Santa Cruz']
        },
        {
          nombre: 'Maule',
          comunas: ['Talca', 'Consitución', 'Curepto', 'Empedrado', 'Maule', 'Pelarco', 'Pencahue', 'Río Claro', 'San Clemente', 'San Rafael', 'Cauquenes', 'Chanco', 'Pelluhue', 'Curicó', 'Hualañé', 'Licantén', 'Molina', 'Rauco', 'Romeral', 'Sagrada Familia', 'Teno', 'Vichuquén', 'Linares', 'Colbún', 'Longaví', 'Parral', 'Retiro', 'San Javier', 'Villa Alegre', 'Yerbas Buenas']
        },
        {
          nombre: 'Ñuble',
          comunas: ['Chillán', 'Bulnes', 'Cobquecura', 'Coelemu', 'Ñiquén', 'Pemuco', 'Pinto', 'Quillón', 'San Carlos', 'San Fabián', 'San Ignacio', 'El Carmen', 'Pinto', 'San Nicolás']
        },
        {
          nombre: 'Bío bío',
          comunas: ['Concepción', 'Coronel', 'Chiguayante', 'Florida', 'Hualqui', 'Lota', 'Penco', 'San Pedro de la Paz', 'Santa Juana', 'Talcahuano', 'Tomé', 'Hualpén', 'Lebu', 'Arauco', 'Cañete', 'Contulmo', 'Curanilahue', 'Los Álamos', 'Tirúa', 'Los Ángeles', 'Antuco', 'Cabrero', 'Laja', 'Mulchén', 'Nacimiento', 'Negrete', 'Quilaco', 'Quilleco', 'San Rosendo', 'Santa Bárbara', 'Tucapel', 'Yumbel', 'Alto Biobío']
        },
        {
          nombre: 'La Araucanía',
          comunas: ['Temuco', 'Carahue', 'Cunco', 'Curarrehue', 'Freire', 'Galvarino', 'Gorbea', 'Lautaro', 'Loncoche', 'Melipeuco', 'Nueva Imperial', 'Padre las Casas', 'Perquenco', 'Pitrufquén', 'Pucón', 'Saavedra', 'Teodoro Schmidt', 'Toltén', 'Vilcún', 'Villarrica', 'Cholchol']
        },
        {
          nombre: 'Los Ríos',
          comunas: ['Valdivia', 'Corral', 'Lanco', 'Los Lagos', 'Máfil', 'Mariquina', 'Paillaco', 'Panguipulli', 'La Unión', 'Futrono', 'Lago Ranco', 'Río Bueno']
        },
        {
          nombre: 'Los Lagos',
          comunas: ['Puerto Montt', 'Calbuco', 'Cochamó', 'Fresia', 'Frutillar', 'Los Muermos', 'Llanquihue', 'Maullín', 'Puerto Varas', 'Castro', 'Ancud', 'Chonchi', 'Curaco de Vélez', 'Dalcahue', 'Puqueldón', 'Queilén', 'Quellón', 'Quemchi', 'Quinchao', 'Osorno', 'Puerto Octay', 'Purranque', 'Puyehue', 'Río Negro', 'San Juan de la Costa', 'San Pablo', 'Chaitén', 'Futaleufú', 'Hualaihué', 'Palena']
        },
        {
          nombre: 'Aysén',
          comunas: ['Coyhaique', 'Lago Verde', 'Aysén', 'Cisnes', 'Guaitecas', 'Cochrane', 'O`Higgins', 'Tortel', 'Chile Chico', 'Río Ibáñez']
        },
        {
          nombre: 'Magallanes',
          comunas: ['Punta Arenas', 'Laguna Blanca', 'Río Verde', 'San Gregorio', 'Cabo de Hornos', 'Antártica', 'Porvenir', 'Primavera', 'Timaukel', 'Natales', 'Torres del Paine']
        }
        // Agrega más regiones y comunas aquí
      ],
      comunas: [],
      productoD: '',
      lineaD: '',
      fechaD: '',
      nombreD: '',
      correoD: '',
      telefonoD: '',
      tamanoD: '',
      horaD: '',
      productoQD: '',
      rutD: '',
      ciudadD: '',
      producto_reclamo: '',
      linea: '',
      fecha: '',
      nombre: '',
      correo: '',
      telefono: '',
      hora: '',
      tamano: '',
      productoQ: '',
      rut: '',
      ciudad: '',
      title: '',
      text: '',
      errormsg: '',
      nombreOrigen: '',
      emailOrigen: '',
      telefonoOrigen: '',
      codeClient: '',
      localAdress: '',
      phone: '',
      fantasyNameLocal: '',
      firstName: '',
      lastName: '',
      detailAttention: '',
      comment: '',
      detailAttentionDisabled: 0,
      name: '',
      date: '',
      regionS: '',
      comuna: '',
      regionD: '',
      comunaD: '',
      selectRegion: '',
      base64: '',
      file: null,
      image: null,
      base64Data: ''

    }
  },
  computed: {},
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'CCUReclamoForm') return
      if (e.evento === 'newdata') {
        this.productoD = e.dato.producto_reclamo ? e.dato.producto_reclamo : ''
        this.lineaD = e.dato.fields.linea ? e.dato.fields.linea : ''
        this.fechaD = e.dato.fields.fecha ? e.dato.fields.fecha : ''
        this.nombreD = e.dato.fields.name ? e.dato.fields.name : ''
        this.correoD = e.dato.fields.email ? e.dato.fields.email : ''
        this.telefonoD = e.dato.fields.phone ? e.dato.fields.phone : ''
        this.tamanoD = e.dato.fields.tamano ? e.dato.fields.tamano : ''
        this.horaD = e.dato.fields.hora ? e.dato.fields.hora : ''
        this.productoQD = e.dato.fields.productoQ ? e.dato.fields.productoQ : ''
        this.rutD = e.dato.fields.rut ? e.dato.fields.rut : ''
        this.ciudadD = e.dato.fields.ciudad ? e.dato.fields.ciudad : ''
        this.regionD = e.dato.fields.region ? e.dato.fields.region : ''
        this.comunaD = e.dato.fields.comuna ? e.dato.fields.comuna : ''

        // data

        this.producto_reclamo = this.productoD
        this.linea = this.lineaD
        this.fecha = this.fechaD
        this.nombre = this.nombreD
        this.correo = this.correoD
        this.telefono = this.telefonoD
        this.tamano = this.tamanoD
        this.hora = this.horaD
        this.productoQ = this.productoQD
        this.rut = this.rutD
        this.ciudad = this.ciudadD
        this.regionS = this.regionD
        this.comuna = this.comunaD
      }
    })
  },
  methods: {
    updateComunas () {
      if (this.selectedRegion !== null) {
        this.comunas = this.regiones[this.selectedRegion].comunas
        this.selectRegion = this.regiones[this.selectedRegion].nombre
        this.selectedComuna = null
      } else {
        this.comunas = []
        this.selectedComuna = null
      }
    },
    handleImageUpload (e) {
      const file2 = e.target.files[0]
      this.file = file2
      this.image = URL.createObjectURL(file2)
      if (file2) {
        const reader = new FileReader()

        reader.onload = () => {
          // The result contains the base64 encoded string
          this.base64Data = reader.result.split(',')[1]
          this.base64 = reader.result
        }
        reader.readAsDataURL(file2)
      }
    },
    _clearError () {
      this.errormsg = ''
    },
    focusTo (el) {
      this.$refs[el].focus()
    },
    _formatearRut (val) {
      this.rut = utils.cleanSpecialChars(val, 'rut')
      this.rut = utils.formatearRut(this.rut)
    },
    keyPressCheckSpecialChars (evt, type) {
      return utils.keyPressCheckSpecialChars(evt, type)
    },
    cleanSpecialChars (val, type) {
      if (!val) return
      return (this[val] = utils.cleanSpecialChars(this[val], type))
    },
    _sentClick () {
      this.errormsg = ''
      if (!this.producto_reclamo) {
        this.$refs.producto_reclamo.focus()
        this.errormsg = 'Debes el producto'
        return
      }
      if (!this.nombre) {
        this.$refs.nombre.focus()
        this.errormsg = 'Debes ingresar Nombre'
        return
      }
      if (!this.correo) {
        this.$refs.correo.focus()
        this.errormsg = 'Debes ingresar Correo'
        return
      }
      if (!this.telefono) {
        this.$refs.telefono.focus()
        this.errormsg = 'Debes ingresar telefono'
        return
      }
      if (!this.tamano) {
        this.$refs.tamano.focus()
        this.errormsg = 'Debes seleccionar tamaño'
        return
      }
      if (!this.productoQ) {
        this.errormsg = 'Debes ingresar mensaje'
        return
      }
      if (!this.rut) {
        this.$refs.rut.focus()
        this.errormsg = 'Debes ingresar rut'
        return
      }
      if (!this.ciudad) {
        this.$refs.ciudad.focus()
        this.errormsg = 'Debes ingresar dirección'
        return
      }
      if (!this.selectedComuna) {
        this.$refs.selectedComuna.focus()
        this.errormsg = 'Debes ingresar comuna'
        return
      }
      if (!this.selectedRegion) {
        this.$refs.selectedRegion.focus()
        this.errormsg = 'Debes ingresar region'
        return
      }
      if (!this.selectedComuna) {
        this.$refs.selectedComuna.focus()
        this.errormsg = 'Debes ingresar comuna'
        return
      }
      if (!this.selectedRegion) {
        this.$refs.selectedRegion.focus()
        this.errormsg = 'Debes ingresar region'
        return
      }
      serverUI.$emit('FormEvent', {
        form: 'CCUReclamoForm',
        evento: 'sentClick',
        data: {
          type: 'ccu-reclamo-form-confirm',
          fields: {
            producto_reclamo: this.producto_reclamo,
            linea: this.linea ? this.linea : 'No especificado',
            fecha: this.fecha ? this.fecha : 'No especificado',
            nombre: this.nombre,
            correo: this.correo,
            telefono: this.telefono,
            tamano: this.tamano,
            hora: this.hora ? this.hora : 'No especificado',
            productoQ: this.productoQ,
            rut: this.rut,
            ciudad: this.ciudad,
            comuna: this.selectedComuna,
            regionS: this.selectRegion,
            url: `https://www.google.com/maps/place/${this.ciudad.replace(/\s+/g, '+')},${this.selectedComuna.replace(/\s+/g, '+')},+Regi%C3%B3n+${this.selectRegion.replace(/\s+/g, '+')}/`,
            base64: this.base64 ? this.base64 : 'No especificado'
          }
        }
      })
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'CCUReclamoForm',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.form__field {
  margin-bottom: 7px;
}

.form-box-body {
    height: 340px;
}
</style>
